import React from 'react';
import ExploreLayout from '../components/ExploreLayout';
import ExploreMission from '../components/ExploreMission';
import ExploreSuccess from '../components/ExploreSuccess';
import useExplore from '../hooks/useExplore';

export default function ExploreNeoPage() {
  const { state } = useExplore();
  const companyName = state.answers?.companyName || 'MatrixOS Demo';

  return (
    <ExploreLayout
      stepId="neo"
      eyebrow="Neo Experience"
      title={`Run the morning shift at ${companyName}.`}
      subtitle="This placeholder prepares the Neo mission path. In the next sprint, this becomes an interactive execution assurance journey using the personalized demo company."
      nextLabel="Continue to Morpheus"
    >
      <div className="explore-split">
        <ExploreMission
          title="Mission: Stabilize execution"
          description="You are the operations manager. One site has overdue duties and Neo already knows what should happen next."
          tasks={[
            'Check the live operations overview',
            'Open the overdue duty',
            'Review proof and response timeline',
            'Resolve the escalation',
          ]}
        />
        <div className="explore-console">
          <div className="explore-console-header">
            <span>Neo Command Centre</span>
            <strong>{companyName}</strong>
          </div>
          <div className="explore-console-screen">
            <div className="explore-console-row"><span>Execution Score</span><strong>97.9%</strong></div>
            <div className="explore-console-row"><span>Staff on Shift</span><strong>34</strong></div>
            <div className="explore-console-row"><span>Duties Today</span><strong>198</strong></div>
            <div className="explore-console-row"><span>Responses in Progress</span><strong>4</strong></div>
          </div>
        </div>
      </div>
      <ExploreSuccess title={`${companyName} is ready`} description="N3 can replace this card with the real guided Neo simulator." />
    </ExploreLayout>
  );
}
